import React, { useCallback, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ToastContainer, toast } from "react-toastify";
import CustomPagination from "../../../components/CustomPagination";
import {
  getEmployeeTodayCheckInListPath,
  employeeCheckInAndOutResetPath,
} from "../../../services/config";
import {
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { LuTimerReset } from "react-icons/lu";
import debounce from "lodash/debounce";
import { Form } from "react-bootstrap";

const CurrentDateEmployeeInfo = () => {
  const user = JSON.parse(localStorage.getItem("user_data")) || {};
  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);

  const [employeeInfoList, setEmployeeInfoList] = useState([]);
  const [filteredEmployeeInfoList, setFilteredEmployeeInfoList] = useState([]);
  const [resetCheckInOut, setResetCheckInOut] = useState({
    id: "",
    staffId: "",
    isOpenPopup: false,
  });
  const [filterUser, setFilterUser] = useState([]);


  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getEmployeeInfo = useCallback(() => {
    const data = {
      path: getEmployeeTodayCheckInListPath,
      data: {
        userId: user.user_id,
      },
    };
    dispatch(commonSaveData(data));
  }, []);

  useEffect(() => {
    getEmployeeInfo();
  }, []);

  const resetEmployee = (id, staffId) => {
    setResetCheckInOut((pre) => ({
      ...pre,
      id: id,
      staffId: staffId,
      isOpenPopup: true,
    }));
  };

  const resetEmployeeNo = () => {
    setResetCheckInOut((pre) => ({
      ...pre,
      isOpenPopup: false,
    }));
  };

  const resetEmployeeCheckInOut = () => {
    const data = {
      path: employeeCheckInAndOutResetPath,
      data: { id: resetCheckInOut.id, staffId: resetCheckInOut.staffId },
    };
    dispatch(commonSaveDataOne(data));
  };

  useEffect(() => {
    if (commonStore.commonSuccess) {
      setEmployeeInfoList(commonStore.commonData);
      setFilteredEmployeeInfoList(commonStore.commonData)
      dispatch(initCommonState());
    }
    if (commonStore.commonError) {
      setEmployeeInfoList([]);
      dispatch(initCommonState());
    }
    // -------------------------------------------
    if (commonStore.commonSuccessOne) {
      toast.success(commonStore.commonMessageOne);
      dispatch(initCommonState());
      getEmployeeInfo();
      setResetCheckInOut((pre) => ({
        ...pre,
        isOpenPopup: false
      }))
    }
    if (commonStore.commonErrorOne) {
      toast.error(commonStore.commonMessageOne);
      dispatch(initCommonState());
      setResetCheckInOut((pre) => ({
        ...pre,
        isOpenPopup: false
      }))
    }
  }, [commonStore, dispatch]);

  const heading = [
    {
      headerName: "S.No",
      field: "sno",
      width: 80,
      sortable: false,
      filter: false,
      suppressMovable: true,
      pinned: "left",
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "500",
        padding: "0px",
        margin: "0px",
      },
      headerClass: "text-center",
      valueGetter: (params) => {
        if (!params || !params.node) return '';

        const api = params.api;
        const rowIndex = params.node.rowIndex;

        if (!api) return rowIndex + 1;

        try {
          const paginationEnabled = api.isPaginationActive();
          if (paginationEnabled) {
            const currentPage = api.paginationGetCurrentPage();
            const pageSize = api.paginationGetPageSize();
            return (currentPage * pageSize) + rowIndex + 1;
          }
          return rowIndex + 1;
        } catch (error) {
          return rowIndex + 1;
        }
      },
      comparator: (valueA, valueB, nodeA, nodeB) => {
        const indexA = nodeA?.rowIndex ?? 0;
        const indexB = nodeB?.rowIndex ?? 0;
        return indexA - indexB;
      }
    },
    {
      headerName: "Employee Id",
      field: "empId",
      width: 150,
      cellStyle: {
        textAlign: "left",
        display: "flex",
        alignItems: "center",
      },
      headerClass: "text-left",
    },
    {
      headerName: "Staff Name",
      field: "fullName",
      width: 250,
      cellStyle: {
        textAlign: "left",
        display: "flex",
        alignItems: "center",
      },
      headerClass: "text-left",
    },
    {
      headerName: "In Time",
      field: "intime",
      width: 150,
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      headerClass: "text-center",
    },
    {
      headerName: "Out Time",
      field: "outtime",
      width: 150,
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      headerClass: "text-center",
    },
    {
      headerName: "Total Hours",
      field: "totalHours",
      width: 150,
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      headerClass: "text-center",
      cellRenderer: (rowData) => rowData.data.totalHours || "-",
    },
    {
      headerName: "Action",
      width: 150,
      cellStyle: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px",
      },
      headerClass: "text-center",
      cellRenderer: (rowData) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            padding: "0px",
            margin: "0px",
          }}
        >
          <button
            className="universal-btn"
            style={{
              height: "32px",
              width: "90px",
              lineHeight: "10px",
              fontSize: "14px",
              padding: "0px",
              margin: "0px",
            }}
            onClick={() => resetEmployee(rowData.data.id, rowData.data.staffId)}
          >
            Reset
          </button>
        </div>
      ),
    },
  ];

  const paginationPageSize = 10;

  const handleSearch = useCallback(
    debounce((query, dataList) => {
      const debouncedQuery = query.trim().toLowerCase();
      const results = dataList.filter(
        (employee) =>
          (employee.fullName &&
            employee.fullName.toLowerCase().includes(debouncedQuery)) ||
          (employee.empId &&
            employee.empId.toLowerCase().includes(debouncedQuery))
      );
      setEmployeeInfoList(results);
      setFilteredEmployeeInfoList(dataList);
    }, 500),
    []
  );

  const searchUser = (event) => {
    const {
      target: { value },
    } = event;
    setFilterUser(value);
    handleSearch(value, filteredEmployeeInfoList);
  };

  return (
    <div className="color-white">
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <Dialog
        open={resetCheckInOut.isOpenPopup}
        onClose={resetEmployeeNo}
        maxWidth="xs" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogContent>
          <DialogContentText
            id="scroll-dialog-description"
            tabIndex={-1}
            style={{ position: "relative" }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center gap-2">
              <LuTimerReset style={{ fontSize: "40px" }} className="color-white" />
              <h2 className="color-white">RESET</h2>
              <h3 className="color-white mb-3">
                Are you sure! you want to reset?
              </h3>
              <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                <button
                  style={{
                    width: "120px",
                    height: "35px",
                    fontSize: "15px",
                    border: "1px solid gray",
                    borderRadius: "12px",
                    backgroundColor: "transparent"
                  }}
                  className="color-white"
                  onClick={resetEmployeeNo}
                >
                  No
                </button>
                <button
                  style={{
                    width: "120px",
                    height: "35px",
                    fontSize: "15px",
                  }}
                  className="universal-btn"
                  onClick={resetEmployeeCheckInOut}
                >
                  Yes
                </button>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Widgets
        icon={
          <WidgetsIcon
            icon={
              <Link to="/setting/" className="icon-color">
                <ArrowBackIcon />
              </Link>
            }
            title="Current Date Employee Information"
          />
        }
        body={
          <>
            <Form.Group className="mt-3 mb-3 px-4">
              <Form.Control
                placeholder="Search by Employee Name & ID"
                onChange={searchUser}
                name="filterUser"
                value={filterUser}
                className="universal-input-one"
                style={{ width: "250px" }}
              />
            </Form.Group>

            <div
              className="ag-theme-quartz custom-grid"
              style={{
                height: "calc(100vh - 220px)",
                width: "100%",
                padding: "0 20px",
                marginTop: "10px",
                // Add these CSS variables for consistent styling
                '--ag-cell-horizontal-padding': '8px',
                '--ag-header-cell-horizontal-padding': '8px',
                '--ag-row-height': '48px',
                '--ag-header-height': '48px',
                '--ag-cell-horizontal-border': 'solid #ddd',
                '--ag-cell-horizontal-border-width': '1px',
              }}
            >
              <AgGridReact
                rowData={Array.isArray(employeeInfoList) ? employeeInfoList : []}
                columnDefs={heading}
                pagination={true}
                paginationPageSize={paginationPageSize}
                onGridReady={onGridReady}
                // Add these props for consistent row/header sizing
                rowHeight={48}
                headerHeight={48}
                suppressCellFocus={true}
                // Add default column definition
                defaultColDef={{
                  resizable: true,
                  sortable: false,
                  filter: false,
                  suppressMenu: true,
                }}
                // Optional: Add these for better grid behavior
                onFirstDataRendered={(params) => {
                  params.api.sizeColumnsToFit();
                }}
                onGridSizeChanged={(params) => {
                  params.api.sizeColumnsToFit();
                }}
              />
            </div>
            <div className="d-flex align-items-center justify-content-between custom-pagination px-3">
              {gridApi && <CustomPagination gridApi={gridApi} />}
            </div>
          </>
        }
      />
    </div>
  );
};

export default CurrentDateEmployeeInfo;
